import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private snackBar = inject(MatSnackBar);

  showSuccess(message: string) {
    this.showSnackbar(message, {
      panelClass: ['success-snackbar'],
      duration: 0,
      dismissOnClick: true,
    });
  }

  showError(message: string) {
    this.showSnackbar(message, {
      panelClass: ['error-snackbar'],
      duration: 0,
      dismissOnClick: true,
    });
  }

  showWarning(message: string) {
    this.showSnackbar(message, {
      panelClass: ['warning-snackbar'],
      duration: 3500,
      dismissOnClick: false,
    });
  }

  private showSnackbar(
    message: string,
    options: {
      panelClass: string[];
      duration: number;
      dismissOnClick: boolean;
    }
  ) {
    const snackbarRef = this.snackBar.open(message, '', {
      duration: options.duration,
      horizontalPosition: 'left',
      verticalPosition: 'bottom',
      panelClass: options.panelClass,
    });

    if (options.dismissOnClick) {
      const clickHandler = () => {
        snackbarRef.dismiss();
      };
      document.addEventListener('click', clickHandler, { once: true });
      snackbarRef.afterDismissed().subscribe(() => {
        document.removeEventListener('click', clickHandler);
      });
    }
  }
}
